import React, { useState, useEffect } from 'react';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Typography, Button, Box, Grid } from '@mui/material';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { getApiHeader } from 'utlis/commonfunctions';
import Loader from 'layouts/nbn/components/loader';

const SERVER_URL = process.env.REACT_APP_API_URL;

const MyWorkPlanInfo = () => {

  const navigate = useNavigate();
  const [reviewers, setReviewers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5); // Items per page

  const handleViewDetails = (startDate, endDate) => {
    navigate('/my_work_plan_info_edit', { state: { startDate, endDate } });
  };

  const handleWeekChange = async (e) => {

    setLoading(true);

    const headers = await getApiHeader();

    try {
      const response = await axios.post(`${SERVER_URL}work-plan/get-my-work-plan-list`, {}, {
        headers: headers
      });

      if (response.data && response.data.data && Array.isArray(response.data.data.work_plan)) {
        setReviewers(response.data.data.work_plan);
      } else {
        setReviewers([]);
      }

    } catch (error) {
      console.error("Error fetching work plan data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleWeekChange({ target: { value: JSON.stringify({ start: '', end: '' }) } });
  }, []);

  // Pagination Logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = reviewers.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(reviewers.length / itemsPerPage);

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div className="container workplanform p-3">
        {/* Reviewer List */}
        <Typography variant="subtitle1" className="mt-3"><h4>My Work Plan List</h4></Typography>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          My Work Plan List details my planned activities, including new shop visits and revisits to stores, scheduled for the week.
        </Typography>
        {loading ? (
          <div className="text-center">
              <Loader />
          </div>
        ) : (
        <div className="table-responsive mt-3">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Sl No</th>
                <th>Work Start date</th>
                <th>Work End date</th>
                <th>Status</th>
                <th>Verified By</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.length > 0 ? currentItems.map((reviewer, index) => (
                <tr key={reviewer.work_plan_id}>
                  <td>{index + 1 + indexOfFirstItem}</td>
                  <td>{reviewer.work_week_start_date}</td>
                  <td>{reviewer.work_week_end_date}</td>
                  <td>
                    {reviewer.status === 1 ? 'Approved' :
                      reviewer.status === 2 ? 'Rejected' :
                        'Pending'}
                  </td>
                  <td>
                    {reviewer.verified_by == 'admin' ? reviewer.admin_user : 
                        reviewer.verified_by == 'manager' ? reviewer.manager_name : 'Not Verified'}
                   ({reviewer.verified_by})
                  </td>
                  <td>
                    {reviewer.status === 2 && (
                      <button
                        className="btn btn-danger btn-sm ms-2" style={{ backgroundColor: '#e20e75' }}
                        onClick={() => handleViewDetails(reviewer.work_week_start_date, reviewer.work_week_end_date)}
                      >
                        View Work Details
                      </button>
                    )}
                  </td>
                </tr>
              )) : (
                <tr>
                  <td colSpan="6" className="text-center">No work plan found for the selected week</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        )}

        {/* Custom Pagination Controls */}
        {currentItems.length > 0 && (
              <div className="pagination-controls text-center mt-3">
                <button
                  className="btn btn-light btn-sm"
                  disabled={currentPage === 1}
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  Previous
                </button>
                <span className="mx-2">{currentPage} of {totalPages}</span>
                <button
                  className="btn btn-light btn-sm"
                  disabled={currentPage === totalPages || totalPages === 0}
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  Next
                </button>
              </div>
            )}
      </div>
    </DashboardLayout>
  );
};

export default MyWorkPlanInfo;
